import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(marketing)/_components/invoice-scan-content.tsx");
